import styled from 'styled-components';

export const StyledGatewaySendCommandPresentation = styled.div`
  h2 {
    color: red;
  }
  h3 {
    color: green;
  }
`;
